import PreferredProducts from "./preferred_products";
import CountryProductButton from "./country_product_button";
import ImageLoader from "./image_loader";
import {CatalogContext} from "./catalog_context";

const backText = gettext("Back");
const titleText = gettext("Click here to go back to countries list");
const freeText = gettext("Free with subscription plan");
const queryKey = catalogModule.getQueryKey();

class ViewProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // products_feature: catalogModule.getDisplayAddons(),
            product: product,
            catalog_data: {}
        };
    }

    componentDidMount() {
        let tempObj = Object.assign({}, catalogModule.catalogData)
        this.setState({
            catalog_data: tempObj
        });
    }

    render() {
        const { product, products_feature } = this.state;
        const staticFeature = catalogModule.getUrl("static_feature");
        let currencyObj = checkCurrencyReact(product);
        let backStoreUrl = catalogModule.getUrl("back_store");
        // let renderProducts = products_feature.map((data, index) => {
        //     if(data.key !== queryKey){
        //         if(index <= 5){
        //             if(queryKey !== data.key){
        //                 return <PreferredProducts product={data} key={index}/>
        //             }
        //         }
        //     }
        // });

        let renderTaxInfo = currencyObj && currencyObj.tax_info ? <i className="tax_info">${currencyObj.tax_info}</i> : null;
        let renderNonConsumable = product.type === 'non-consumable' ? null : <p className="product-type">{gettext(product.type)}</p> ;
        let renderProductDesc = product.description ? <p className="product-desc">{product.description}</p> : null;
        const isPkgFree = product.type !== "free" && product.hasOwnProperty("included_in_pkg") && product.included_in_pkg !== "not_included";
        let renderImage;
        if(product.hasOwnProperty("thumbnailURL") && product.thumbnailURL){
            renderImage = product.thumbnailURL;
        } else if(product.hasOwnProperty("thumbnailurl") && product.thumbnailurl){
            renderImage = product.thumbnailurl;
        } else {
            renderImage = catalogModule.getUrl("static_na_product");
        }
        return (
            <CatalogContext.Provider value={this.state}>
                <div className="view_product">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item" key={100}>
                                <a className="has-text-link" id="backtostore" data_link={backStoreUrl}
                                   title={titleText}>
                                    <i className="bi bi-chevron-left"></i>
                                    {backText}
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page"
                                key={200}>{product.name ? product.name : ""}</li>
                        </ol>
                    </nav>
                    <hr/>
                    <div className="row my-6">
                        <div className="col-md-4">
                            <div className="addon-item-img">
                                <ImageLoader src={renderImage}
                                             key={product.key}
                                             alt={product.name}
                                             skelWidth={'100%'}
                                             skelHeight={'384px'}
                                             imgClass={"img-fluid"}/>
                                {/*<img key={product.key} src={renderImage} alt={product.name} className="img-fluid"/>*/}
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="addon-item">
                                <div className="product-content-header">
                                    <h4>{product.name}</h4>
                                    {(product.featured || product.featured === 0) &&
                                        <img src={staticFeature} alt="featured_product"/>}
                                </div>
                                {renderNonConsumable}
                                <p>
                                    <i className="product-price">
                                        {currencyObj.temp_price ? currencyObj.temp_price : ''} {product.type === 'consumable' ? '/credit ' : ''}
                                    </i>
                                    <i className="product-price-tax">{renderTaxInfo}</i>
                                    <i className="product-price-desc">
                                        {/*{product.type === 'subscription' && gettext("Add to cart to see upgrade price")}*/}
                                    </i>
                                </p>
                                <p>
                                    <i className="product-price-sub">{isPkgFree && freeText}</i>
                                </p>
                                {renderProductDesc}
                                <p className="product-credit">{product.credit}</p>
                            </div>
                            <div className="addon-item-button">
                                <CountryProductButton product={product} width={"half"}/>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <PreferredProducts product={product}/>
                </div>
            </CatalogContext.Provider>
        );
    }
}

export default ViewProduct;
